import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for partners' products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view for displaying data
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (devConfig.getPermAction('partnersTypeProductEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: 'Partner', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SiteId', // Column ID
                                    header: _('Site ID'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Key', // Column ID
                                    header: _('Clave'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Url', // Column ID
                                    header: _('URL API'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeIntegration', // Column ID
                                    header: _('Tipo de integración'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '0',
                                            value: _('Lobby con token propio'), // Option for own token lobby
                                        },
                                        {
                                            id: '1',
                                            value: _(
                                                'Lobby con token de proveedor', // Option for provider token lobby
                                            ),
                                        },
                                        { id: '2', value: _('Productos') }, // Option for products
                                    ],
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Contingency', // Column ID
                                    header: _('Contingencia'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit event
                                    $$('editwinPartnerProducts').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'PartnersProducts/GetPartnersTypeProduct'; // API endpoint for fetching data
        var cthis = this; // Reference to the current context
        var providers = []; // Array to hold provider data
        var popup = webix.ui({
            // Configuration for the edit popup window
            view: 'window',
            id: 'editwinPartnerProducts', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 470 : 590, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Partner') }, // Label for editing partner
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: false, // Non-modal window
            body: {
                // Body configuration
                view: 'scrollview',
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form view for editing
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 470 : 540, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text',
                            label: 'Id', // Label for ID field
                            name: 'Id', // Name for ID field
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text',
                            label: _('Partner'), // Label for partner field
                            name: 'Partner', // Name for partner field
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Estado'), // Label for status field
                            name: 'IsActivate', // Name for status field
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') }, // Active option
                                { id: 'I', value: _('Inactivado') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text',
                            label: _('Site ID'), // Label for Site ID field
                            name: 'SiteId', // Name for Site ID field
                            attributes: { type: 'number' }, // Input type
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text',
                            label: _('Clave'), // Label for Key field
                            name: 'Key', // Name for Key field
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text',
                            label: _('URL API'), // Label for API URL field
                            name: 'Url', // Name for API URL field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'checkbox',
                            label: _('KEY'), // Label for KEY checkbox
                            name: 'ChangeKey', // Name for KEY checkbox
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo',
                            label: _('Tipo de integración'), // Label for integration type field
                            name: 'TypeIntegration', // Name for integration type field
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: '0', value: _('Lobby con token propio') }, // Own token lobby option
                                {
                                    id: '1',
                                    value: _('Lobby con token de proveedor'), // Provider token lobby option
                                },
                                { id: '2', value: _('Productos') }, // Products option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Contingencia'), // Label for contingency field
                            name: 'Contingency', // Name for contingency field
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') }, // Active option
                                { id: 'I', value: _('Inactivado') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'), // Label for explanation field
                                    name: 'Note', // Name for explanation field
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input type
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'), // Cancel button label
                                    click: function () {
                                        // Click event to hide the window
                                        this.getTopParentView().hide();
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Save button label
                                    click: function ($e) {
                                        // Click event for saving
                                        var values = $$('editform').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/UpdatePartnerTypeProduct', // API endpoint for updating
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('editform').clear(); // Clear form on success
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                _(
                                                                    'Tipo Producto Partner Editado', // Success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Configuration for the add popup window
            view: 'window',
            id: 'AddPartnerProducts', // ID for the add window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 650 : 450, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Tipo Producto Partner') }, // Label for adding partner product type
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                // Body configuration
                view: 'scrollview',
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form view for adding
                    id: 'addform', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 650 : 400, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'combo',
                            label: _('Tipo'), // Label for type field
                            name: 'Type', // Name for type field
                            value: 'CASINO', // Default value
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'CASINO', value: _('Casino') }, // Casino option
                                {
                                    id: 'PAYMENT',
                                    value: _('Pasarela de Pagos'), // Payment gateway option
                                },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Partner'), // Label for partner field
                            name: 'Partner', // Name for partner field
                            labelWidth: 150, // Label width
                            options: profile.Partners, // Options from profile
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Estado'), // Label for status field
                            name: 'IsActivate', // Name for status field
                            value: 'A', // Default value
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') }, // Active option
                                { id: 'I', value: _('Inactivado') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text',
                            label: _('URL API'), // Label for API URL field
                            name: 'Url', // Name for API URL field
                            labelWidth: 150, // Label width
                            value: '', // Default value
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Tipo de integración'), // Label for integration type field
                            name: 'TypeIntegration', // Name for integration type field
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: '0', value: _('Lobby con token propio') }, // Own token lobby option
                                {
                                    id: '1',
                                    value: _('Lobby con token de proveedor'), // Provider token lobby option
                                },
                                { id: '2', value: _('Productos') }, // Products option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo',
                            label: _('Contingencia'), // Label for contingency field
                            name: 'Contingency', // Name for contingency field
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') }, // Active option
                                { id: 'I', value: _('Inactivado') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'), // Cancel button label
                                    click: function () {
                                        // Click event to hide the window and clear form
                                        this.getTopParentView().hide();
                                        $$('addform').clear();
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Save button label
                                    click: function ($e) {
                                        // Click event for saving
                                        var values = $$('addform').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/CreatePartnerTypeProduct', // API endpoint for creating
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('addform').clear(); // Clear form on success
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                _(
                                                                    'Tipo Producto Partner Agregado', // Success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            // Event handler for adding product partner
            popupAdd.show(); // Show add window
            var optionsCountries = $$('AddProvider').getList(); // Get list of providers
            optionsCountries.clearAll(); // Clear existing options
            optionsCountries.parse(providers); // Parse new options
        });
        var filter = ''; // Initialize filter variable
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            // Event handler for filtering partner products
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for double-click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch providers
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Providers/GetProductProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize ID field
                            .replace(/"Name"/g, '"value"'), // Normalize Name field
                    );
                    console.log(data); // Log fetched data
                    providers = data.Data; // Store provider data
                },
            });
    }
}

// FILE DOCUMENTED
